import React from "react";

const GiftListComp = ()=>{

    return (
        <div>List</div>
    );

};

export default GiftListComp;